import { jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { generateJsxKey } from './util.generate-jsx-key.js';

const textNodeToJsxPrinter = (node, context) => {
  const trimmed = node.value.trim();
  if (!trimmed) {
    return /* @__PURE__ */ jsx(Fragment, { children: node.value }, generateJsxKey(context));
  }
  return /* @__PURE__ */ jsx("span", { children: node.value }, generateJsxKey(context));
};

export { textNodeToJsxPrinter };
//# sourceMappingURL=common.text.js.map
